import React, { useState } from 'react'
import styles from './personalCard.module.scss'
import userInfo from 'utils/userInfo'
import { Layout } from 'components'
import ActivityInfo from './components/ActivityInfo/ActivityInfo'
import ArrivalInfo from './components/ArrivalInfo/ArrivalInfo'
import DiplomaticRankInfo from './components/DiplomaticRankInfo/DiplomaticRankInfo'
import FamilyStatusInfo from './components/FamilyStatusInfo/FamilyStatusInfo'
import MilitaryInfo from './components/MilitaryInfo/MilitaryInfo'
import AwardsInfo from './components/AwardsInfo/AwardsInfo'
import ProfilePage from 'pages/ProfilePage/ProfilePage'
import VacationInfo from './components/VacationInfo/VacationInfo'
import EducationInfo from './components/EducationInfo/EducationInfo'
import BodyCheckInfo from './components/BodyCheckInfo/BodyCheckInfo'
import LocationInfo from './components/LocationInfo/LocationInfo'
import ManningTableInfo from './components/ManningTableInfo/ManningTableInfo'
import SubdivisionsInfo from './components/SubdivisionsInfo/SubdivisionsInfo'
import { getPersonalEmployee } from 'service/PersonalCardService'
import { useEffect } from 'react'
import { setPersonalInfo } from 'store/slices/PersonalCard'
import { useDispatch, useSelector } from 'react-redux'
import TrainQualificationInfo from './components/TrainQualificationInfo/TrainQualificationInfo'
import { useNavigate } from 'react-router-dom'
import LanguagesInfo from './components/LanguagesInfo/LanguagesInfo'
import Passport from './components/PassportInfo/Passport'
import PersonalMenuCardByProfile from '../PersonalMenu/PersonalMenuCardByProfile'

const PersonalCard = () => {
  const [main, setMain] = useState(true)
  const [render, setRender] = useState(false)
  const navigate = useNavigate()
  const [open, setOpen] = useState({
    title: '',
  })
  let data
  const dispatch = useDispatch()
  const user = userInfo()
  const getData = async () => {
    try {
      let response = await getPersonalEmployee(data, 'ru')

      dispatch(
        setPersonalInfo({
          personal_info: response.data,
        }),
      )
    } catch (error) { }
  }

  useEffect(() => {
    getData()
    setRender(false)
  }, [render])

  const info = useSelector((state) => state.personalcard.personal_info)
  const [backgroundImage, setBackgroundImage] = useState(
    localStorage.getItem('background'),
  )
  return (
    <Layout>
      <h2 className={styles.Personal_Card}>Мой профиль</h2>
      <div className={styles.personal_wrapper}>

        <div className={styles.header}>

          <div className={styles.header_body}>
            <div className={styles.personal_info}>
              <PersonalMenuCardByProfile setBackground={setBackgroundImage} />
            </div>

          </div>
        </div>
     

      </div>

    </Layout>
  )
}

export default PersonalCard
